import { useEffect, useState } from 'react';
import {
  DelegateSection,
  FinalCta,
  Hero,
  ObjectionSection,
  PricingSection,
  ProblemSection,
  SiteFooter,
  SiteHeader,
  SocialProofSection,
  ValueSection,
  WorkflowSection,
} from '@/components/Sections';
import LeadForm from '@/components/LeadForm';
import Modal from '@/components/Modal';
import { initAnalytics, track } from '@/lib/analytics';
import { form, privacy } from '@/config/collectionsLanding';

export default function CollectionsLanding() {
  const [formOpen, setFormOpen] = useState(false);

  useEffect(() => {
    initAnalytics();
    track('collections_landing_view');
  }, []);

  const openForm = () => {
    track('collections_cta_click');
    track('collections_wizard_opened');
    setFormOpen(true);
  };

  const closeForm = () => setFormOpen(false);

  return (
    <div className="min-h-screen bg-slate-50 text-ink-900">
      <SiteHeader />
      <main>
        <Hero onCtaClick={openForm} />
        <DelegateSection onCtaClick={openForm} />
        <ProblemSection />
        <WorkflowSection />
        <ValueSection />
        <ObjectionSection />
        <PricingSection onCtaClick={openForm} />
        <SocialProofSection />
        <FinalCta onCtaClick={openForm} />
      </main>
      <SiteFooter />

      <Modal
        open={formOpen}
        onClose={closeForm}
        title={form.startCta}
        subtitle="כמה שאלות קצרות. בלי חיבור מערכת, בלי כרטיס אשראי."
        labelledBy="lead-form-title"
      >
        <LeadForm />
        {privacy.href && (
          <p className="mt-4 text-center text-xs text-ink-400">
            <a
              href={privacy.href}
              className="underline transition hover:text-ink-600"
              target="_blank"
              rel="noopener noreferrer"
            >
              {privacy.label}
            </a>
          </p>
        )}
      </Modal>
    </div>
  );
}
